import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';

export const ContainerOuterStyled = styled.div`
    background: ${colors.white};
    border-top: 5px solid ${colors.azure};

    @media ${mediaQueries.md} {
        border-top: none;
        padding: 24px;
    }
`;

export const ContainerInnerStyled = styled.div`
    @media ${mediaQueries.md} {
        display: flex;
    }
`;

export const ImageContainerStyled = styled.div`
    @media ${mediaQueries.md} {
        margin-right: 24px;
    }
`;

export const ImageStyled = styled.img`
    height: 126px;
    object-fit: cover;
    width: 100%;

    @media ${mediaQueries.md} {
        height: 64px;
        width: 64px;
    }
`;

export const BodyContainerStyled = styled.div`
    padding: 24px;
    width: 100%;

    @media ${mediaQueries.md} {
        display: flex;
        padding: 0;
    }
`;
